import AgeGroup from '@/models/AgeGroup'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1,
    },
    ageGroupDetails: null,
  },

  mutations: {
    setAgeGroupList(state, ageGroups) {
      each(ageGroups, (ageGroup) => {
        const exist = find(state.list, { id: ageGroup.id })
        if (!exist) {
          state.list.push(new AgeGroup(ageGroup))
        }
      })
    },

    clearAgeGroupList(state) {
      state.list = []
    },

    setAgeGroupListMeta(state, meta) {
      state.listMeta = meta
    },

    setAgeGroupDetails(state, ageGroup) {
      if (ageGroup instanceof AgeGroup) {
        state.ageGroupDetails = ageGroup
      } else {
        state.ageGroupDetails = new AgeGroup(ageGroup)
      }
    },

    clearAgeGroupDetails(state) {
      state.ageGroupDetails = null
    },
  },

  actions: {
    async getAgeGroups({ commit }, params) {
      const query = AgeGroup.page(params.page || 1).orderBy(params.sort)
      if (params.search) {
        query.where('search', params.search)
      }

      const res = await query.params({ limit: 20 }).get()
      commit('setAgeGroupList', res.data)
      commit('setAgeGroupListMeta', res.meta)
    },

    async getAgeGroupDetails({ commit }, id) {
      const { data } = await Api.get(`admin/age-groups/${id}`)
      commit('setAgeGroupDetails', data.data)
    },

    async createAgeGroup({ commit }, formData) {
      const { data } = await Api.post(`admin/age-groups`, formData)
      commit('setAgeGroupDetails', data.data)
    },

    async updateAgeGroup({ commit }, formData) {
      const { data } = await Api.put(
        `admin/age-groups/${formData.id}`,
        formData
      )
      commit('setAgeGroupDetails', data.data)
    },

    async deleteAgeGroup({ commit }, id) {
      await Api.delete(`admin/age-groups/${id}`)
      commit('clearAgeGroupDetails', id)
    },

    async exportToExcel({ commit }, params) {
      let endpoint = params.search
        ? `admin/age-groups/export/${params.search}`
        : `admin/age-groups/export`
      const file = await Api.get(endpoint, {
        responseType: 'blob',
      })
      return file
    },
  },
}
